module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Search-5c98a9b72c0a84452ec1187fcba83bf9.svg";